export default __webpack_public_path__ + "static/sweepstakes-prize-05-0060566098d8fc8268d17b8359ab50b7.jpg";